module.exports = __webpack_public_path__ + "static/media/flower_event.60cd9837.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/flower_event.jpg
// module id = 257
// module chunks = 0